'use strict';function e(r){return `rizzui-${r}`}exports.a=e;